import axios from "axios";
import { buildApiUrl } from "../config/api";

export async function requestTrialExtension({ schoolId, message }) {
    const res = await axios.post(buildApiUrl("/Subscription/trial-extension-request"), {
        schoolId,
        message: message || undefined,
    });
    return res.data;
}
